import clsx from 'clsx';
import type { HeadingProps } from './Heading.types';

const Heading = ({ as, variant, children, ...props }: HeadingProps) => {
  const HeadingElement = as ?? 'h2';
  const levelStyles = {
    h1: 'typography-title-2 md:typography-title1',
    h2: 'typography-title-3 md:typography-title2',
    h3: 'typography-title-4 md:typography-title-3',
    h4: 'typography-title-4',
    h5: 'typography-title-5',
    h6: 'typography-title-6'
  };
  const styles = clsx(levelStyles[variant ?? HeadingElement]);

  return (
    <HeadingElement className={styles} {...props}>
      {children}
    </HeadingElement>
  );
};

export { Heading };
